import { t } from "i18next";

function ConfirmDeleteModal({ onCancel, onConfirm,deleteMsg }) {
  return (
    <div className="popup-overlay ">
          <div className="popup-content !w-[447px] !p-[22px]" onClick={(e) => e.stopPropagation()}>
            <div className='text-[15px] pt-[13px] font-medium text-[#000] w-full flex justify-center items-center flex-col'>
              <span>{t('Are_u_sure')}</span>
              <span>{deleteMsg}</span>
            </div>

            <div className='flex items-center mt-[35px] gap-[9px]'>
              <div className='w-[50%]'>
                <button className='w-full h-[52px] rounded-[26px] bg-[#E5E5E5] text-[15px] font-[600] text-[#36367A]'
                  onClick={onCancel}>
                  {t('btnCancel')}
                </button>
              </div>
              <div className='w-[50%]'>
                <button className='w-full h-[52px] rounded-[26px] bg-[#FF5252] text-[15px] font-[600] text-white'
                  onClick={onConfirm}>
                  {t('btnDelete')}
                </button>
              </div>
            </div>

          </div>
        </div>
  );
}

export default ConfirmDeleteModal;